import { Request } from '~src/httpClient/serverApi/requests/Request';
import { IResult } from '~src/httpClient/serverApi/types/IResponse';

export interface IGeneratePasswordResetTokenParams {
  username: string;
}

export interface IGeneratePasswordResetTokenResult extends IResult {
}

export class GeneratePasswordResetTokenRequest extends Request<IGeneratePasswordResetTokenParams, IGeneratePasswordResetTokenResult> {
  constructor(params: IGeneratePasswordResetTokenParams) {
    super('generatePasswordResetToken', params);
  }
}
